import React, { useState, useEffect } from 'react';

const questionPreviews = {
  default: [
    '1. 자기소개 부탁드립니다.',
    '2. 지원자께서는 우리 회사 지원 동기를 말씀해주세요.',
    '3. 본인의 장단점을 말씀해주세요.',
    '4. 지원자께서는 지원하신 직무가 어떤일을 하는지 알고 계신가요?',
    '5. 우리회사에 대해 알고 있는대로 말씀해주세요.',
    '6. 지원자께서는 지원하는 직무를 위해서 어떤 노력을 하셨나요?',
    '7. 지원자께서는 입사후에 하고 싶은 것이 있다면 말씀해주세요.',
    '8. 지원자께서는 어떤 상황일때 스트레스를 받으시나요? 그리고 어떻게 푸시나요?',
    '9. 많은 지원자들 가운데 왜 본인을 뽑아야 한다고 생각하시나요?',
    '10. 마지막으로 하고 싶은 말이 있다면 말씀해주세요.'
  ],
  deep: [
    '1. 이제까지 살아오면서 가장 어려웠던(힘들었던) 경험은 무엇이었나요?',
    '2. 야근이나 주말출근에 대해 어떻게 생각하나요?',
    '3. 상사와 의견이 다를때는 어떻게 하실건가요?',
    '4. 다른 사람을 배려하고 도움을 제공하여 긍정적인 영향을 주었던 경험에 대해서 말씀해 주세요',
    '5. 직업선택시 본인이 가장 중요하게 생각하는것은 무엇인가요?',
    '6. 상사가 부당한 업무를 지시했을때는 어떻게 행동하실건가요?',
    '7. 5년 후에는 어떤모습일지 생각해본적 있나요?',
    '8. 개인의 전문성 향상과 팀의 협업 능력 향상 중에서 더 우선시해야 한다고 생각하는 것과 이유를 말씀해주세요.',
    '9. 지원자께서는 어떤사람과 일하고 싶지 않은가요? 그 사람과 일하게 된다면 어떻게 하실건가요?',
    '10. 주변사람들은 지원자를 어떻게 평가하나요?'
  ],
  situation: [
    '1. 고객이 무리한 요구를 하며 화를 내고 있습니다. 어떻게 상황을 해결하시겠습니까?',
    '2. 팀원과 의견이 다를 때 직접 대화로 해결하는 것과 팀장이나 제3자를 통해 조율하는 것 중에서 더 효과적이라고 생각하는 것과 이유를 말씀해주세요.',
    '3. 동료가 실수를 했을 때, 아무 일 없었다는 듯이 넘어가는 것과 다소 분위기가 어색해질지라도 실수를 언급하는 것 중에서 더 필요하다고 생각하는 것과 이유를 말씀해주세요.',
    '4. 예산이 절반으로 줄어든 상황에서 프로젝트를 완료해야 합니다. 어떤 전략을 사용하시겠습니까?',
    '5. 업무를 배울 때 동료나 선배가 귀찮게 여길지라도 모르는 것은 바로바로 질문하는 것과 일단 시간이 걸려도 최대한 알아본 이후에 질문하는 것 중에서 더 좋은 자세라고 생각하는 것과 이유를 말씀해주세요.',
    '6. 나의 능력을 인정받을 수는 있지만 성장에 도움이 되지 않는 프로젝트와 성장에는 큰 도움이 되지만 나의 존재가 크게 드러나지 않는 프로젝트 중에서 더 원하는 것과 이유를 말씀해주세요.',
    '7. 상사가 부당하다고 생각되는 업무지시를 했습니다. 어떻게 행동하시겠습니까?',
    '8. 정해진 마감일을 지키지 못 하더라도 완벽하게 일을 하는 것과 정해진 마감일은 지킬 수 있지만 미완성으로 일을 하는 것 중에서 더 중요하다고 생각하는 것과 이유를 말씀해주세요.',
    '9. 야근이 계속되어 개인시간이 없어진 상황입니다. 어떻게 해결하시겠습니까?',
    '10. 즉흥적인 친구, 계획적인 친구와 함께 여행 갔을 때 어떻게 할 것인가요?'
  ],
  custom: [
    '📌 직무질문은 38개 직무별로 구성되어 있습니다.',
    '',
    '💼 개발자, 마케팅, 영업, 디자인, 간호사,',
    '회계, 재무, 인사총무, 법무, 구매팀 등',
    '',
    '각 직무에 특화된 전문 질문 10개가 준비되어 있습니다.',
    '',
    '👉 직무를 선택하시면 해당 직무의 질문을 확인하실 수 있습니다.'
  ],
  admission: [
    '1. 자기소개 부탁드립니다.',
    '2. 우리대학을 지원한 이유는 말씀해주세요.',
    '3. 지원하신 학과를 선택한 이유를 말씀해주세요.',
    '4. 고등학교 때 어려움을 겪었던 경험과 극복과정을 말씀해주세요.',
    '5. 본인의 강점과 약점은 무엇이며, 약점은 어떻게 보완하고 계신가요?',
    '6. 입학하신 후 학업계획이 있다면 말씀해주세요.',
    '7. 고등학교 때 가장 기억에 남는 경험이 있다면 말씀해주세요. 학업, 동아리, 봉사활동등 자유롭게 말씀해주세요.',
    '8. 본인이 지원한 전공을 위해서 노력한 부분이 있다면 말씀해주세요.',
    '9. 최근 읽은 책 중 인상 깊었던 책과 그 이유를 말씀해주세요.',
    '10.대학에 입학하면 무엇을 하고 싶나요? 동아리나 공부 등 자유롭게 말씀해주세요.',
    '11. 졸업 후 진로 계획이 있다면 말씀해주세요.',
    '12. 최근 관심 있는 사회 이슈를 말씀해주세요.',
    '13. 본인을 뽑아야 되는 이유를 말씀해주세요.',
    '14. 본인만의 좌우명이나 인생관이 있다면 말씀해주세요.',
    '15. 마지막으로 하고 싶은 말이 있다면 말씀해주세요.'
  ]
};

function SelectMode({ onModeSelect, onBack, darkMode }) {
  const [showPreview, setShowPreview] = useState(null);

// 🆕 미리보기 팝업 열릴 때 페이지 중간으로 스크롤 (직무선택 위치)
useEffect(() => {
  if (showPreview) {
    setTimeout(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight / 3,
        behavior: 'smooth'
      });
    }, 100);
  }
}, [showPreview]);

  const cardClass = darkMode 
    ? 'bg-gray-800 text-white' 
    : 'bg-white text-gray-800';

  const handlePreview = (mode) => {
    setShowPreview(mode);
  };

   const closePreview = () => {
    setShowPreview(null);
  };

  return (
    <div className={`p-8 rounded-2xl shadow-2xl max-w-5xl w-full text-center transition-all duration-500 ${cardClass}`}>
      {/* 🎯 상단 타이틀 */}
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold mb-3 text-gray-800">
          💼 면접 유형을 선택하세요
        </h2>
        <p className="text-lg text-gray-600">
          4단계 체계적 면접 연습 + AI역량검사 대비 + 입시면접 + 행운응원까지!
        </p>
      </div>
      
      {/* 📋 면접 진행 안내 */}
      <div className={`text-left space-y-3 mb-8 p-6 rounded-xl ${darkMode ? 'bg-gray-700 bg-opacity-50' : 'bg-gray-50'}`}>
        <h3 className="text-2xl font-bold text-center mb-4">📋 면접 진행 안내</h3>
        <div className="space-y-2 text-base">
          <p>📝 면접유형별 10개의 질문 (입시면접 15개)</p>
          <p>⏱️ 각 질문당 45초 답변 시간</p>
          <p>➕ 부족한 경우 15초 / 30초 연장 버튼</p>
          <p>📊 면접 종료 후 피드백 제공</p>
          <p className="text-center font-semibold text-blue-600">😎 너무 걱정 마세요! AI는 절대 화내지 않아요!</p>
        </div>
      </div>
      
      {/* 🔥 2x3 그리드 - 모던 카드 */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {/* 기본질문 */}
        <div className="p-8 rounded-2xl bg-white border-2 border-blue-200 shadow-md hover:shadow-xl hover:border-blue-400 hover:-translate-y-1 transition-all duration-300 cursor-pointer">
          <div className="text-center mb-4">
            <div className="text-6xl mb-4">📝</div>
            <h3 className="text-3xl font-bold mb-2 text-gray-800">기본질문</h3>
            <p className="text-base text-gray-600">
              자기소개·지원동기·장단점 등<br/>
              면접 필수 질문 10개
            </p>
          </div>
          <div className="flex gap-3 mt-4">
            <button 
              onClick={() => handlePreview('default')}
              className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all"
            >
              미리보기
            </button>
            <button 
              onClick={() => onModeSelect('default')}
              className="flex-1 px-4 py-3 bg-blue-500 text-white font-semibold rounded-xl hover:bg-blue-600 transition-all"
            >
              시작하기
            </button>
          </div>
        </div>

        {/* 심화질문 */}
        <div className="p-8 rounded-2xl bg-white border-2 border-purple-200 shadow-md hover:shadow-xl hover:border-purple-400 hover:-translate-y-1 transition-all duration-300 cursor-pointer">
          <div className="text-center mb-4">
            <div className="text-6xl mb-4">📚</div>
            <h3 className="text-3xl font-bold mb-2 text-gray-800">심화질문</h3>
            <p className="text-base text-gray-600">
              가치관·경험·문제해결 인성관련 등<br/>
              심층 질문 10개
            </p>
          </div>
          <div className="flex gap-3 mt-4">
            <button 
              onClick={() => handlePreview('deep')}
              className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all"
            >
              미리보기
            </button>
            <button 
              onClick={() => onModeSelect('deep')}
              className="flex-1 px-4 py-3 bg-purple-500 text-white font-semibold rounded-xl hover:bg-purple-600 transition-all"
            >
              시작하기
            </button>
          </div>
        </div>

        {/* 직무질문 */}
        <div className="p-8 rounded-2xl bg-white border-2 border-green-200 shadow-md hover:shadow-xl hover:border-green-400 hover:-translate-y-1 transition-all duration-300 cursor-pointer">
          <div className="text-center mb-4">
            <div className="text-6xl mb-4">💼</div>
            <h3 className="text-3xl font-bold mb-2 text-gray-800">직무질문</h3>
            <p className="text-base text-gray-600">
              개발자·마케팅·디자인 등<br/>
              38개 직무 전문질문
            </p>
          </div>
          <div className="mt-4">
            <button 
              onClick={() => onModeSelect('custom')}
              className="w-full px-4 py-3 bg-green-500 text-white font-semibold rounded-xl hover:bg-green-600 transition-all"
            >
              직무 선택하기
            </button>
          </div>
        </div>

        {/* 상황질문 */}
        <div className="p-8 rounded-2xl bg-white border-2 border-orange-200 shadow-md hover:shadow-xl hover:border-orange-400 hover:-translate-y-1 transition-all duration-300 cursor-pointer">
          <div className="text-center mb-4">
            <div className="text-6xl mb-4">🎯</div>
            <h3 className="text-3xl font-bold mb-2 text-gray-800">상황질문</h3>
            <p className="text-base text-gray-600">
              실무 상황대응 훈련<br/>
              AI역량검사 대비 10개
            </p>
          </div>
          <div className="flex gap-3 mt-4">
            <button 
              onClick={() => handlePreview('situation')}
              className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all"
            >
              미리보기
            </button>
            <button 
              onClick={() => onModeSelect('situation')}
              className="flex-1 px-4 py-3 bg-orange-500 text-white font-semibold rounded-xl hover:bg-orange-600 transition-all"
            >
              시작하기
            </button>
          </div>
        </div>

        {/* 🆕 입시면접 */}
        <div className="p-8 rounded-2xl bg-white border-2 border-pink-200 shadow-md hover:shadow-xl hover:border-pink-400 hover:-translate-y-1 transition-all duration-300 cursor-pointer">
          <div className="text-center mb-4">
            <div className="text-6xl mb-4">🎓</div>
            <h3 className="text-3xl font-bold mb-2 text-gray-800">입시면접</h3>
            <p className="text-base text-gray-600">
              수시·정시 대학입시<br/>
              전문질문 15개
            </p>
          </div>
          <div className="flex gap-3 mt-4">
            <button 
              onClick={() => handlePreview('admission')}
              className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-all"
            >
              미리보기
            </button>
            <button 
              onClick={() => onModeSelect('admission')}
              className="flex-1 px-4 py-3 bg-pink-500 text-white font-semibold rounded-xl hover:bg-pink-600 transition-all"
            >
              시작하기
            </button>
          </div>
        </div>

        {/* 🆕 행운응원 */}
        <div className="p-8 rounded-2xl bg-white border-2 border-yellow-200 shadow-md hover:shadow-xl hover:border-yellow-400 hover:-translate-y-1 transition-all duration-300 cursor-pointer">
          <div className="text-center mb-4">
            <div className="text-6xl mb-4">🍀</div>
            <h3 className="text-3xl font-bold mb-2 text-gray-800">행운응원</h3>
            <p className="text-base text-gray-600">
              면접 전 응원메시지로<br/>
              긍정 에너지 충전
            </p>
          </div>
          <div className="mt-4">
            <button 
              onClick={() => onModeSelect('lucky')}
              className="w-full px-4 py-3 bg-yellow-500 text-white font-semibold rounded-xl hover:bg-yellow-600 transition-all"
            >
              🥠 포춘쿠키 열기
            </button>
          </div>
        </div>
      </div>
      {/* 🔍 미리보기 팝업 */}
      {showPreview && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
          <div className={`relative max-w-3xl w-full p-8 rounded-3xl shadow-2xl max-h-[80vh] overflow-y-auto ${cardClass}`}>
            <button 
              onClick={closePreview}
              className="absolute top-4 right-4 text-3xl hover:scale-110 transition-transform"
            >
              ✕
            </button>

            <h3 className="text-2xl font-bold mb-6">
              {showPreview === 'default' && '📝 기본질문 미리보기'}
              {showPreview === 'deep' && '📚 심화질문 미리보기'}
              {showPreview === 'situation' && '🎯 상황질문 미리보기'}
              {showPreview === 'custom' && '💼 직무질문 안내'}
              {showPreview === 'admission' && '🎓 입시면접 미리보기'}
            </h3>

            <div className="space-y-3 mb-6">
              {questionPreviews[showPreview].map((q, idx) => (
                <div key={idx} className={`p-3 rounded-lg ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
                  <p className="text-left">{q}</p>
                </div>
              ))}
            </div>

            <div className="flex gap-3">
              <button
                onClick={closePreview}
                className="flex-1 px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white font-semibold rounded-xl transition-all"
              >
                닫기
              </button>
              <button
                onClick={() => {
                  closePreview();
                  onModeSelect(showPreview);
                }}
                className="flex-1 px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-xl transition-all"
              >
                🚀 면접 시작!
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SelectMode;